import { Collapse } from 'antd';
import styled from 'styled-components';

import { CustomFilterPopover } from 'components/data/helpers/filterPopover.style';

import { multiSelectWiderClickableAreaStyles } from '../TableFilterMultiSelect';

const ASSET_FILTER_MAX_HEIGHT_PX = 560;
const ASSET_FILTER_LABEL_WIDTH = '7.5rem';

export const AssetFilterPopover = styled(CustomFilterPopover)`
  color: ${({ theme }) => theme.headerColor};
  display: flex;
  flex-direction: column;
  max-height: min(${ASSET_FILTER_MAX_HEIGHT_PX}px, 70vh);
  overflow: hidden;
`;

export const AssetFilterInnerContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 8px;
  width: 100%;

  .ant-alert {
    margin-bottom: 0.5rem;
  }
`;

export const AssetFilterActions = styled.div.attrs({
  className: 'ant-table-filter-dropdown-btns',
})`
  border-top: 1px solid ${({ theme }) => theme.borderColor};
  flex-shrink: 0;
`;

export const AssetFilterWarning = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.red};
  padding-bottom: 8px;
`;

export const AssetSelectContainer = styled.div<{ $selectWidth?: string }>`
  align-items: flex-start;
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  width: 100%;

  > span:first-of-type {
    box-sizing: border-box;
    flex: 0 0 ${ASSET_FILTER_LABEL_WIDTH};
    line-height: 1.25;
    min-height: 32px;
    padding-top: 0.35rem;
    text-align: right;
    white-space: normal;
    width: ${ASSET_FILTER_LABEL_WIDTH};
    word-break: break-word;
  }

  > :not(span:first-of-type) {
    ${({ $selectWidth }) =>
      $selectWidth ? `flex: 0 0 ${$selectWidth}; width: ${$selectWidth}` : 'flex: 1 1 auto'};
    min-width: 0;
  }

  .ant-select {
    width: 100%;
  }

  ${multiSelectWiderClickableAreaStyles}
`;

export const ComponentFiltersCollapse = styled(Collapse)`
  margin: 0;
  width: 100%;

  .ant-collapse-expand-icon {
    padding-inline-end: 0 !important;
  }

  .ant-collapse-content-box {
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    padding: 8px !important;
  }
`;

export { ASSET_FILTER_MAX_HEIGHT_PX };
